import { looksInternalError } from './customerError';

/** Persist venue dashboard section so return from Stripe opens Settings → Payments. */
const DASHBOARD_SECTION_KEY_PREFIX = 'venue-dashboard-active-section';
const DASHBOARD_SUBSECTION_KEY_PREFIX = 'venue-dashboard-active-subsection';

export const getStripeConnectCallbackPath = () => '/stripe/connect/callback';

export const buildStripeConnectCallbackUrl = (origin) =>
  `${String(origin || '').replace(/\/$/, '')}${getStripeConnectCallbackPath()}`;

export const persistVenueDashboardPaymentsSection = (venueId) => {
  if (!venueId || venueId === 'unknown') return;
  const key = String(venueId);
  try {
    localStorage.setItem(`${DASHBOARD_SECTION_KEY_PREFIX}:${key}`, 'settings');
    localStorage.setItem(`${DASHBOARD_SUBSECTION_KEY_PREFIX}:${key}`, 'payments');
  } catch {
    // ignore
  }
};

export const buildVenueDashboardPaymentsUrl = (venueId) => {
  if (!venueId || venueId === 'unknown') return '/venue-dashboard';
  return `/venue-dashboard?venueId=${encodeURIComponent(String(venueId))}`;
};

/** User-friendly copy for OAuth return query params. */
export const resolveStripeConnectReturnCopy = ({ result, message }) => {
  const raw = typeof message === 'string' ? message.trim() : '';
  if (result === 'success') {
    return {
      type: 'success',
      title: 'Stripe connected',
      message:
        raw ||
        'Your Stripe account is linked. Open Payments to view payout status or finish any remaining steps.'
    };
  }

  const lower = raw.toLowerCase();
  if (
    lower.includes('invalid or expired') ||
    lower.includes('already used') ||
    lower.includes('oauth state')
  ) {
    return {
      type: 'error',
      title: 'Connection link expired',
      message:
        'This Stripe link was already used or has expired (for example if you used the browser Back button). ' +
        'Go to Payments in your venue dashboard and click Connect with Stripe to start again.'
    };
  }

  if (lower.includes('access_denied') || lower.includes('denied')) {
    return {
      type: 'error',
      title: 'Stripe connection cancelled',
      message: 'You cancelled connecting Stripe. You can try again anytime from Payments in your venue dashboard.'
    };
  }

  return {
    type: 'error',
    title: 'Stripe connection failed',
    message:
      raw && !looksInternalError(raw)
        ? raw
        : 'Something went wrong connecting Stripe. Please try again from Payments in your venue dashboard.'
  };
};
